'use client';

import type { FlattenedThemeType } from '@unifyapps/defs/theme/types';
import { createContext, useContext } from 'react';

const ActiveThemeContext = createContext<FlattenedThemeType | undefined>(undefined);

export const ActiveThemeContextProvider = ActiveThemeContext.Provider;

export function useActiveThemeContext() {
  return useContext(ActiveThemeContext);
}
